import {useMsal} from '@azure/msal-react'
import {loginRequest} from '../../auth/auth-config'
import giveprismLogo from '../../icons/GP_Logo_Login_TM.svg'
import {Divider, Grid} from '@mui/material'
import {useEffect} from 'react'
import GivePrismLogo from '../Common/GivePrismLogo'
import deloitteLogoBlack from '../../icons/deloitte-logo-black.svg'
import {
  BoxContainer,
  ButtonContainer,
  DivContainer,
  LogoContainer,
  StyledCookieButton,
  StyledFooterDiv,
  StyledBox,
  StyledButton,
  StyledImageDiv,
  StyledPaper,
  StyledTypography,
  StyledImage,
  StyledImageGridDiv,
  StyledGrid
} from './SignInStyles'
import theme from '../../themes'
import prismLogo from '../../icons/prism_logo.svg'

export const openInNewTab = (url) => {
  globalThis.open(url, '_blank', 'noopener,noreferrer')
}

const SignIn = () => {
  const {instance} = useMsal()

  useEffect(() => {
    // Set the body background color when the component mounts
    document.body.style.backgroundColor = theme.palette.common.white

    // Reset the body background color when the component unmounts
    return () => {
      document.body.style.backgroundColor = theme.palette.common.black
    }
  }, [])

  const handleLogin = () => {
    handleLoginRedirect(instance)
  }

  const handleLoginRedirect = async (msalInstance) => {
    await msalInstance.handleRedirectPromise()
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 0) {
      msalInstance.loginRedirect({loginRequest})
    }
  }

  return (
    <DivContainer>
      <Grid container spacing={2} sx={{height: '100vh'}}>
        <StyledGrid item xs={12} sm={6} md={6} lg={6}>
          <LogoContainer>
            <GivePrismLogo logoPath={giveprismLogo} defaultHeight={'85px'} />
          </LogoContainer>
          <BoxContainer>
            <StyledBox>
              <StyledPaper elevation={5}>
                <StyledTypography>Sign in with</StyledTypography>
                <Divider />
                <ButtonContainer>
                  <StyledButton onClick={handleLogin}>Log into GivePrism</StyledButton>
                </ButtonContainer>
              </StyledPaper>
            </StyledBox>
          </BoxContainer>
        </StyledGrid>
        <StyledImageGridDiv item xs={12} sm={6} md={6} lg={6}>
          <StyledImage src={prismLogo} alt="Prism Logo" />
        </StyledImageGridDiv>
      </Grid>
      <StyledFooterDiv>
        <div style={{textAlign: 'center', margin: 'auto', display: 'table', verticalAlign: 'middle'}}>
          <StyledCookieButton
            onClick={() => openInNewTab('https://cookienotice.deloitte.com')}
            target="_href"
            rel="noopener noreferrer"
          >
            Cookies
          </StyledCookieButton>
          <StyledCookieButton onClick={() => globalThis.OneTrust?.ToggleInfoDisplay()}>
            Cookie Settings
          </StyledCookieButton>
        </div>
        <StyledImageDiv>
          <img src={deloitteLogoBlack} width="100px" height="50px" alt="Deloitte Logo" />
        </StyledImageDiv>
      </StyledFooterDiv>
    </DivContainer>
  )
}

export default SignIn
